import { FC } from 'react';
import LocalAtm from '@mui/icons-material/LocalAtm';
import TabsPanel from 'further-ui/components/TabsPanel';
import { LP_CAPITAL_ACTION_CREATE } from 'adminConstants/routes';
import Page from 'components/new/Page';
import CapitalActionsSummary from './CapitalActionsSummary';
import CapitalActions from './CapitalActions';

const ListCapitalActions: FC = () => {
  const tabs = [
    {
      key: 'capital-actions',
      label: 'Capital actions',
      content: <CapitalActions />,
    },
  ];

  return (
    <Page
      tabTitle="Capital actions"
      heading="Capital actions"
      headingIcon={LocalAtm}
      withHeadingDivider
      spacing="lg"
      actions={[
        {
          label: 'Start new action',
          link: LP_CAPITAL_ACTION_CREATE,
          variant: 'contained',
        },
      ]}
    >
      <CapitalActionsSummary />
      <TabsPanel useTabsUrls tabs={tabs} />
    </Page>
  );
};

export default ListCapitalActions;
